import _ from "lodash";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import * as Api from "../../../common/Api";
import config from "../../../config";
import {readString} from "react-papaparse";

const initialState = {
    listType: 'IMPORT_COMPANY',
    importRestricted: false,
    inputSource: 'FILE_UPLOAD', // [TEXT_INPUT, FILE_UPLOAD]
    fileName: '',
    fileSize: 0,
    fileType: 'csv',
    textInput: '',
    rawTextInput: '',
    listName: '',
    listDescription: '',
    fieldMappings: [],
    fileHeaders: [],
    mappingAttributes: [],
    totalRecords: 0,
    loading: false,
    importing: undefined,
    importStatus: undefined,
    notifyByEmailOnSuccessOrFailure: undefined
}

export const getFieldMappings = createAsyncThunk('lists/mapping-types', async (arg, {getState, rejectWithValue}) => {
    try {
        const MAPPING_ATTR_URL = `${config.services.ATLAS.apiUrl}/lists/mapping-types`;
        const attr = await Api.get(true, MAPPING_ATTR_URL);
        if (attr) {
            if (_.isArray(attr)) {
                const mapping = _.find(attr, function (o) {
                    return o.listType === getState().upload.listType;
                });
                if (mapping && mapping.attributes)
                    return _.sortBy(mapping.attributes, ['ordinalPosition']);
            }
        }
        console.warn('No field mappings found for listType:', getState().upload.listType);
        return [];
    } catch (error) {
        console.error('Error fetching field mappings:', error);
        return rejectWithValue(error.message);
    }
});

const uploadSlice = createSlice({
    name: 'uploadSlice', initialState,
    reducers: {
        resetUploadState: (state, action) => {
            state.listType = action.payload.listTypeId;
            state.importRestricted = action.payload.importRestricted;
            state.inputSource = 'FILE_UPLOAD'; // [TEXT_INPUT, FILE_UPLOAD]
            state.fileName = '';
            state.fileSize = 0;
            state.fileType = 'csv';
            state.textInput = '';
            state.listName = '';
            state.listDescription = '';
            state.fieldMappings = [];
            state.fileHeaders = [];
            state.mappingAttributes = [];
            state.totalRecords = 0;
            state.loading = false;
            state.importing = undefined;
            state.importStatus = undefined;
            state.rawTextInput = undefined;
            state.notifyByEmailOnSuccessOrFailure = undefined;
        },
        updateListType: (state, action) => {
            state.listType = action.payload;
        },
        updateImportRestricted: (state, action) => {
            state.importRestricted = action.payload;
        },
        updateInputSource: (state, action) => {
            state.inputSource = action.payload;
            if (state.inputSource === 'FILE_UPLOAD') {
                state.rawTextInput = '';
                state.textInput = '';
            } else {
                state.fileName = '';
            }
        },
        updateListName: (state, action) => {
            state.listName = action.payload;
        },
        updateListDescription: (state, action) => {
            state.listDescription = action.payload;
        },
        updateFileName: (state, action) => {
            state.fileName = action.payload;
        },
        updateFileSize: (state, action) => {
            state.fileSize = action.payload;
        },
        updateFileType: (state, action) => {
            state.fileType = action.payload;
        },
        updateImporting: (state, action) => {
            state.importing = action.payload;
        },
        updateImportStatus: (state, action) => {
            state.importStatus = action.payload;
        },
        updateNotifyByEmailOnSuccessOrFailure: (state, action) => {
            state.notifyByEmailOnSuccessOrFailure = action.payload;
        },
        updateTextInput: (state, action) => {
            state.rawTextInput = action.payload;

            const result = readString(_.trim(action.payload));
            const data = result && result.data;
            const headers = result && result.data && result.data[0];
            if (data && headers) {
                const dataWithNoHeader = _.tail(data);
                if (dataWithNoHeader && dataWithNoHeader.length > 0) {
                    const finalText = dataWithNoHeader.map((each) => {
                        return each.reduce(function (accum, currentValue, i) {
                            accum[headers[i]] = currentValue;
                            return accum;
                        }, {});
                    });
                    state.textInput = finalText;
                    state.fileHeaders = headers;
                    state.totalRecords = dataWithNoHeader.length;
                }
            }
        },
        updateFileHeaders: (state, action) => {
            if (action && action.payload)
                state.fileHeaders = action.payload.data;
        },
        resetFileHeaders: (state, action) => {
            state.fileHeaders = [];
        },
        updateMappingAttributes: (state, action) => {
            const attr = action.payload;
            _.remove(state.mappingAttributes, (o) => {
                return o.key === attr.key
            });
            if (attr.header) {
                state.mappingAttributes.push(attr);
            }
        },
        updateTotalRecords: (state, action) => {
            if (action && action.payload)
                state.totalRecords = action.payload.data;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFieldMappings.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getFieldMappings.fulfilled, (state, action) => {
                state.loading = false;
                state.fieldMappings = action.payload || [];
            })
            .addCase(getFieldMappings.rejected, (state, action) => {
                state.loading = false;
            });
    }
})

export const {
    updateListType,
    updateFileHeaders,
    resetFileHeaders,
    updateFileName,
    updateFileSize,
    updateFileType,
    updateListDescription,
    updateListName,
    updateInputSource,
    updateTextInput,
    updateNotifyByEmailOnSuccessOrFailure,
    updateMappingAttributes,
    updateTotalRecords,
    updateImporting,
    updateImportStatus,
    resetUploadState
} = uploadSlice.actions;
export default uploadSlice.reducer;
